module.exports = __webpack_public_path__ + "img/53.80854baf.jpg";